import type { SVGProps } from 'react';
export const LmsO = ({
  color = '#14CD27',
  ...props
}: SVGProps<SVGSVGElement> & {
  color?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 14 15" {...props} data-sentry-element="svg" data-sentry-component="LmsO" data-sentry-source-file="LmsO.tsx">
    <path fill={color} fillRule="evenodd" d="M7 12.114a4.614 4.614 0 1 0 0-9.228 4.614 4.614 0 0 0 0 9.228M7 14.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14" clipRule="evenodd" data-sentry-element="path" data-sentry-source-file="LmsO.tsx" />
  </svg>;